
import { Button, Modal, ModalActions, ModalContent, ModalHeader } from "semantic-ui-react";
import { GetHistoricalMonthlyReconciliations } from "../../graphql/dashboard";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { HMRRow } from "./HMRRow";

export const HMRModal = ({
  open,
  setOpen
}) => {

  const { selectedCompany } = useSelector((state) => state.companyList);
  const getHistoricalMonthlyReconciliations = GetHistoricalMonthlyReconciliations({ companyId: selectedCompany.id });

  const [HMRData, setHMRData] = useState([]);

  useEffect(() => {
    const data = getHistoricalMonthlyReconciliations.data?.getHistoricalMonthlyReconciliations;

    if (!data) return setHMRData([]);
    setHMRData(data);

  }, [getHistoricalMonthlyReconciliations.fetching]);

  useEffect(() => {
    getHistoricalMonthlyReconciliations.reExecuteQuery({ requestPolicy: "network-only" });
  }, [selectedCompany.id])


  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      dimmer="blurring"
      trigger={
        <Button
          className="d-none"
        >
        </Button>
      }
    >
      <ModalHeader>
        Avance de Conciliación
      </ModalHeader>

      <ModalContent>
        <div className="d-flex flex-column gap-3" style={{ height: '500px', overflow: 'auto', paddingRight: '8px' }}>
          {HMRData?.map((hmr) => {
            return (
              <HMRRow key={hmr.period} hmr={hmr} />
            )
          })}
        </div>
      </ModalContent>

      <ModalActions>

      </ModalActions>
    </Modal>
  )
}
